import React, { CSSProperties } from 'react';
import './login.scss';

const AuthLayout = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className="auth-container">
      {/* Lado izquierdo - Formulario */}
      <div className="auth-left-panel">
        <div style={styles.formContainer}>
          <div style={styles.logoContainer}>
            <img
              src="/rapi-fruti-logo.jpeg"
              alt="Rapi-Fruti Logo"
              style={styles.logo}
            />
          </div>
          {children}
        </div>
      </div>

      {/* Lado derecho - Imagen */}
      <div className="auth-right-panel">
        <div style={styles.imageContainer}>
          <img
            src="/frutas-gpt.png"
            alt="Frutas frescas"
            style={styles.backgroundImage}
            loading="eager"
            decoding="sync"
          />
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;

const styles: { [key: string]: CSSProperties } = {
  formContainer: {
    width: '100%',
    maxWidth: '400px',
    display: 'flex',
    flexDirection: 'column',
  },
  logoContainer: {
    textAlign: 'center',
    marginBottom: '30px',
  },
  logo: {
    width: '120px',
    height: '120px',
    objectFit: 'contain',
    borderRadius: '20px',
  },
  imageContainer: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    width: '100%',
    height: '100%',
    margin: 0,
    padding: 0,
  },
  backgroundImage: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    objectPosition: 'center',
    imageRendering: 'crisp-edges',
    filter: 'none',
    backfaceVisibility: 'hidden',
    transform: 'translateZ(0)',
    margin: 0,
    padding: 0,
    border: 'none',
    outline: 'none',
  },
};
